import * as React from "react";
const SvgLogout = (props) => /* @__PURE__ */ React.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	"xmlns:svgjs": "http://svgjs.com/svgjs",
	viewBox: "0 0 48 48",
	height: 48,
	width: 48,
	...props
}, /* @__PURE__ */ React.createElement("title", null, "logout 2 (From Streamline App : https://app.streamlineicons.com)"), /* @__PURE__ */ React.createElement("g", { transform: "matrix(2,0,0,2,0,0)" }, /* @__PURE__ */ React.createElement("path", {
	d: "M 20.249,18.754v1.5c0,0.828-0.672,1.5-1.5,1.5h-4.5 ",
	stroke: "#000000",
	fill: "none",
	strokeWidth: 1.5,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M 14.249,3.754h4.5c0.828,0,1.5,0.672,1.5,1.5v1.5 ",
	stroke: "#000000",
	fill: "none",
	strokeWidth: 1.5,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M 10.393,23.246l-9-1.286c-0.369-0.053-0.644-0.369-0.644-0.742V3.725c0-0.354,0.247-0.66,0.593-0.734l9-2.221 c0.405-0.087,0.804,0.171,0.89,0.576c0.011,0.052,0.017,0.105,0.017,0.158v21c0,0.414-0.336,0.75-0.75,0.75 C10.463,23.254,10.428,23.251,10.393,23.246z ",
	stroke: "#000000",
	fill: "none",
	strokeWidth: 1.5,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M 20.249,9.753l3,3h-8.25 ",
	stroke: "#000000",
	fill: "none",
	strokeWidth: 1.5,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M 20.25,15.753l3-3 ",
	stroke: "#000000",
	fill: "none",
	strokeWidth: 1.5,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M 7.874,11.629 c-0.207,0-0.375,0.168-0.375,0.375s0.168,0.375,0.375,0.375s0.375-0.168,0.375-0.375c0-0.001,0-0.003,0-0.004 c0.001-0.207-0.166-0.374-0.373-0.375c-0.001,0-0.001,0-0.002,0l0,0",
	stroke: "#000000",
	fill: "none",
	strokeWidth: 1.5,
	strokeLinecap: "round",
	strokeLinejoin: "round"
})));
export { SvgLogout as ReactComponent };
